import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import * as cls from "./modalStatementDetail.module.scss";
import { StudentService } from "../studentService";
import { useSelector } from "react-redux";
import {
  Button,
  WidgetFrame,
} from "../../../personal-studio-components/studio";
const service = StudentService;

function ModalStatementDetail({
  selectedHistoryId,
  setIsShowModal,
  approvalDate,
}) {
  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [data, setData] = useState(null);
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const handleClose = () => {
    setIsShowModal(false);
  };
  useEffect(() => {
    if (selectedHistoryId) {
      const request = {
        method: "post",
        path: "/student/elective_discips/statements/detail",
        data: {
          access_token: access_token,
          study_contract_id: contractId,
          selected_history_id: selectedHistoryId,
        },
      };
      service.send(request, setData);
    }
  }, [selectedHistoryId]);
  if (!data)
    return (
      <Dialog
        fullScreen={fullScreen}
        open={true}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        classes={{ paper: cls.dialog_paper }}
      >
        {" "}
        <WidgetFrame icon="loading" title="Идет загрузка" />;
      </Dialog>
    );
  return (
    <Dialog
      fullScreen={fullScreen}
      open={true}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      classes={{ paper: cls.dialog_paper }}
    >
      <DialogContent sx={{ padding: "0" }}>
        {new Date(approvalDate).toLocaleDateString()}
      </DialogContent>
      <h2>Заявление о выборе элективных дисциплин</h2>
      <div>
        Прошу принять мое заявление о выборе элективных дисциплин из блоков
        предусмотренных учебным планом. Выбор элективных дисциплин подтверждаю
      </div>
      <Box>
        {data.map((discip) => (
          <ul>
            <li>{discip.discip_name}</li>
          </ul>
        ))}
      </Box>
      <div>
        <DialogActions classes={{ paper: cls.dialogContnent }}>
          <Button type="primary" onClick={handleClose}>
            Закрыть
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default ModalStatementDetail;
